export default __webpack_public_path__ + "static/media/3.6d3c343e.png";